import React, { useState, useEffect } from "react";
// import ReCAPTCHA from "react-google-recaptcha";
import ReactHtmlParser from 'react-html-parser';
import { Formik, Form, Field, useFormik } from "formik";
import * as Yup from "yup"
import axios from 'axios';
import $ from "jquery";
import { Alert } from "react-bootstrap";
import Swal from 'sweetalert2';
// import '../All_Css/Style.css'
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

const initialValues = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
};

const GetInTouch = () => {
    // To Limit react-simple-captcha to 6 letters.
    useEffect(() => {
        loadCaptchaEnginge(6);
    }, []);
    const GetOBJ1 = [
        {
            id: 1,
            office: "Mumbai Office",
            addresss: "Office 08, 2nd Floor, Kris Korner, Near Swastik Residency, G.B. Road, Thane, Maharashtra-400607",
            email: "info@alobhatechnologies.com",
        },
        {
            id: 2,
            office: "Australia Office",
            addresss: "12 Freestone Avenue, olMelton South <br />Victoria 3338",
            email: "aus@alobhatechnologies.com",
        },
        {
            id: 3,
            office: "Cameroon Office",
            addresss: "i Molyko Buea,Molyko Buea, <br />Cameroon",
            email: "info@alobhatechnologies.com",
        }
    ];
    const GetOBJ2 = [
        {
            id: 1,
            office: "France Office",
            addresss: "FXM BP468 07, 75327, PARIS Cedex 07, <br />France",
            email: "info@alobhatechnologies.com",
        },
        {
            id: 2,
            office: "Rwanda Office",
            addresss: "Acolyte Ventures LTD, 10KG 567 Kacyiru, Po Box 746, Kingli- Rwanda",
            email: "info@acolyte-ventures.com",
        },
        {
            id: 3,
            office: "USA Office",
            addresss: "410 West Bakerview Road Suite 110 Office 116 Bellingham Washington Zip Code 98226 ",
            email: "info@alobhatechnologies.com",
        }
    ];

    const formik = useFormik({
        initialValues: initialValues,

        validationSchema: Yup.object({
            name: Yup.string()
                .min(2, 'Must be 2 characters or more')
                .max(25, 'Must be 25 characters or less')
                .matches(/^[a-zA-Z _)]+$/, "Name should contain only Alphabets")
                .required('Name is required'),
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required')
                .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i, "Email Not Correct"),
            phone: Yup.string()
                .required("Phone number is required")
                .matches(/^[0-9]+$/, "Phone Number should contain only digits")
                .min(10, 'Must be exactly 10 digits')
                .max(10, "Phone Number should not be more than 10 digits"),
            subject: Yup.string()
                .min(2, 'Must be 2 characters or more')
                .required('Subject is required'),
            message: Yup.string()
                .required('Message is required'),
        }),

        onSubmit: (values, { resetForm }) => {
            console.log(values)

            let user_captcha = document.getElementById('user_captcha_input').value;


            if (validateCaptcha(user_captcha) === true) {
                // alert('Captcha Matched');
                let timerInterval
                Swal.fire({
                    title: 'Please Wait...',
                    html: 'Your query is being submitted.',
                    timer: 20000,
                    timerProgressBar: true,
                    didOpen: () => {
                        Swal.showLoading()
                        // const b = Swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                            //   b.textContent = Swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        // console.log('I was closed by the timer')
                    }
                })
                // loadCaptchaEnginge(6); 
                // axios.post('https://tapi.alobhatech.com/post-contact-us', values)
                axios.post('https://www.alobhaapi.alobhatech.com/post-contact-us', values)
                    .then(function (response) {
                        // console.log(response)

                        if (response.status == 200) {
                            // console.log(`Success!`)
                            Swal.fire(
                                'Thank you contacting us .',
                                'We will revert back to your query soon.',
                                'success'
                            )
                            // toast.success("Thank you contacting us . We will revert back to your query soon. ");
                            resetForm();
                        }else if (response.status == 201) {
                            // console.log(`Success!`)
                            Swal.fire(
                                'Thank you contacting us .',
                                'We will revert back to your query soon.',
                                'success'
                            )
                            // toast.success("Thank you contacting us . We will revert back to your query soon. ");
                            resetForm();
                        } else {
                            Swal.fire(
                                'Please try again.',
                                'Something went wrong',
                                'error'
                            )
                        }
                    })
                    .catch(function (error) {
                        console.log(`Error:`, error.response);
                        Swal.fire(
                            'Server Error, Please try again later.',
                            'Something went wrong',
                            'error'
                        )
                        // toast.warn(error.response.data.Message);

                    })
                document.getElementById('user_captcha_input').value = "";
            }

            else {
                // alert('Captcha Does Not Match');
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Captcha Does Not Match !'
                })
                document.getElementById('user_captcha_input').value = "";
            }
            // axios.post('https://alobhaapi.alobhatech.com/post-contact-us', values)
            //     .then(function (response) {
            //         // console.log(response)
            //         if (response.status == 200) {
            //             console.log(`Success!`)
            //             // toast.success("Thank you contacting us . We will revert back to your query soon. ");
            //             resetForm();
            //         }
            //     })
            //     .catch(function (error) {
            //         console.log(`Error:`, error.response)
            //         // toast.warn(error.response.data.Message);

            //     })

        }
    });
    const [verfied, setVerifed] = useState(false);
    //recaptcha function
    function onChange(value) {
        console.log("Captcha value:", value);
        setVerifed(true);

    }


    return (
        <>
            <section className="contact-area py-5">
                <div className="container">
                    <div className="section-title">
                        <h2>Get In Touch With Us</h2>
                        <div className="bar" style={{ zIndex: "-1" }}>&nbsp;</div>
                    </div>
                    <div className="row h-100 justify-content-center ">
                        <div className="col-lg-6 col-md-12">
                            <div style={{ marginTop: "20px" }}>

                                <div className="contact-info-box" style={{ marginBottom: "16px" }}>
                                    <div className="icon">
                                        <img src="assets/img/mail.webp" alt="" loading="lazy"/>
                                    </div>
                                    <h3 className="font-weight-bold">Mail Here</h3>
                                    <p><a href="mailto:sales@alobhatechnologies.com">sales@alobhatechnologies.com</a>, <a
                                        href="mailto:info@alobhatechnologies.com">info@alobhatechnologies.com</a>
                                    </p>
                                </div>

                                <div className="contact-info-box">
                                    <div className="icon">
                                        <img src="assets/img/location.webp" alt="" loading="lazy"/>
                                    </div>
                                    <h3 className="font-weight-bold">Visit Here</h3>
                                    <p>H-106, First Floor, Sector 63, Noida - 201301</p>
                                </div>
                            </div>
                        </div>


                        <div className="col-lg-6 col-md-12 Popup-FM">

                            <div className="desige-form1">

                                <p className="">Anything in your mind. We&#39;ll Be Glad To Assist You!</p>
                                <form onSubmit={formik.handleSubmit} className="form" id="myform" method="POST">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input className="form-control" data-error="Please enter your name" id="name"
                                                    name="name"
                                                    // onKeyPress=
                                                    // onKeyPress={alphaonly}
                                                    placeholder="Name*"
                                                    required
                                                    type="text"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.name} />
                                                <div className="help-block with-errors" >
                                                    {formik.touched.name && formik.errors.name ? (
                                                        <div className='text-danger'>*{formik.errors.name}</div>
                                                    ) : null}
                                                </div>
                                                {/* <div className="help-block with-errors" id="contact_name_error">&nbsp;</div> */}
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input className="form-control" data-error="Please enter your email" id="email"
                                                    name="email"
                                                    placeholder="Email*"
                                                    required
                                                    type="email"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.email} />
                                                <div className="help-block with-errors" >
                                                    {formik.touched.email && formik.errors.email ? (
                                                        <div className='text-danger'>*{formik.errors.email}</div>
                                                    ) : null}
                                                </div>
                                                {/* <div className="help-block with-errors" id="contact_email_error">&nbsp;</div> */}
                                            </div>
                                        </div>

                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input className="form-control" data-error="Please enter your number"
                                                    id="phone"
                                                    maxLength="10"
                                                    minLength="10"
                                                    name="phone"
                                                    placeholder="Phone*"
                                                    required
                                                    type="text"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.phone} />
                                                <div className="help-block with-errors" >
                                                    {formik.touched.phone && formik.errors.phone ? (
                                                        <div className='text-danger'>*{formik.errors.phone}</div>
                                                    ) : null}
                                                </div>
                                                {/* <div className="help-block with-errors" id="contact_phone_error">&nbsp;</div> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="form-group">
                                                <input className="form-control" data-error="Please enter your subject"
                                                    id="subject"
                                                    name="subject"
                                                    onKeyPress="return alphanumeric(event)"
                                                    placeholder="Subject*"
                                                    required
                                                    type="text"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.subject} />
                                                <div className="help-block with-errors" >
                                                    {formik.touched.subject && formik.errors.subject ? (
                                                        <div className='text-danger'>*{formik.errors.subject}</div>
                                                    ) : null}
                                                </div>
                                                {/* <div className="help-block with-errors" id="contact_msg_subject_error">&nbsp;</div> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-12 col-md-12">
                                            <div className="form-group">
                                                <textarea className="form-control" cols="30" data-error="Write your message"
                                                    id="message"
                                                    name="message"
                                                    placeholder="Your Message*"
                                                    required
                                                    rows="5"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.message} ></textarea>
                                                <div className="help-block with-errors" >
                                                    {formik.touched.message && formik.errors.message ? (
                                                        <div className='text-danger'>*{formik.errors.message}</div>
                                                    ) : null}
                                                </div>
                                                {/* <div className="help-block with-errors" id="contact_message_error">&nbsp;</div> */}
                                            </div>
                                        </div>
                                        {/* <div className="col-lg-12 col-md-12"
                                            style={{ paddingBottom: "10px", padding: "13px", justifyContent: "space-between" }}>
                                            <p>
                                                <input type="text" id="captcha12" disabled className="captchacontact" value='26535' />
                                            </p>
                                            <p className='getinto-class'>
                                                <input type="text" name="captcha12" placeholder="Enter Captcha"
                                                    className="captchachanges" />
                                                <button type="button" id="refresh" onClick="" value="refresh"
                                                    className="btn btn-secondary getintpuch-btn"><i className="fa fa-refresh"></i></button>
                                            </p>
                                        </div> */}
                                        {/* <div className='col-lg-12'>
                                            <ReCAPTCHA
                                                sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
                                                onChange={onChange}
                                                required />
                                        </div> */}
                                        <div className="col-lg-12 captcha-parent-class">
                                            < LoadCanvasTemplate reloadText='<i class="fa fa-refresh rotate_cus" aria-hidden="true"></i>' />
                                        </div>
                                        <div className="col-lg-12 captcha-parent-input">
                                            <div><input placeholder="Enter Captcha Value" id="user_captcha_input" name="user_captcha_input" type="text" required></input></div>
                                        </div>
                                        <div className="col-lg-12 col-md-12 mt-2">
                                            {/* {verfied && <button name="submit" value="SUBMIT" className="btn btn-primary reset" id="loderButton1" style={{ backgroundColor: "#f27135" }} ><i className="fa fa-spinner fa-pulse fa-fw" id="loderIcon1"
                                                style={{ display: "none" }}></i>Apply</button>} */}
                                            <button name="submit" value="SUBMIT" className="btn btn-primary reset" id="loderButton1" style={{ backgroundColor: "#f27135" }}
                                            // disabled={!verfied}
                                            ><i className="fa fa-spinner fa-pulse fa-fw" id="loderIcon1"
                                                style={{ display: "none" }}></i>Apply</button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-5">
                        {GetOBJ1.map((card) => {
                            return <div className="col-lg-4 col-md-6 col-sm-12" key={card.id}>
                                <div className="single-footer-widget ">
                                    <h3>{card.office}</h3>
                                    <ul className="footer-contact-info">
                                        <li><i data-feather="map-pin"></i>{ReactHtmlParser(card.addresss)}</li>
                                        {/* <li><i data-feather="map-pin"></i>{card.addresss}</li> */}
                                        <li><i data-feather="mail"></i><a href={`mailto:${card.email}`}>{card.email}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        })}
                    </div>
                    <hr />
                    <div className="row mt-4">
                        {GetOBJ2.map((card) => {
                            return <div className="col-lg-4 col-md-6 col-sm-12" key={card.id}>
                                <div className="single-footer-widget">
                                    <h3>{card.office}</h3>
                                    <ul className="footer-contact-info">
                                        <li><i data-feather="map-pin"></i>{ReactHtmlParser(card.addresss)}
                                        </li>
                                        <li><i data-feather="mail"></i><a
                                            href={`mailto:${card.email}`}>{card.email}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        })}
                    </div>
                    <hr />
                    {/* <div className="row mt-3">
                        <div className="col-lg-12 col-md-12 mt-4">
                            <div className="text-center">
                                <a className="btn btn-info text-capitalize" style={{ fontSize: "16px", fontWweight: "500" }}
                                    href="https://www.designrush.com/agency/software-development/washington"
                                    target="_blank" rel="noopener noreferrer">Software Development Companies In Washington</a>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
        </>
    )
}

export default GetInTouch;